<div class="header-container no-printme">
  <div class="logo-container">
    <a href="#" class="sidebar-toggle" matRipple [matRippleUnbounded]="true" [matRippleCentered]="true"
      (click)="toggleSidebar()">
      <nb-icon [icon]="(materialTheme$ | async) ? 'menu-outline' : 'menu-2-outline'"></nb-icon>
    </a>
    <a style="font-size: 30px;" *ngIf="userDetail" class="logo" href="#" (click)="navigateHome()">
      {{userDetail.shopName}}
    </a>
  </div>

  <!-- <nb-select
    status="primary"
    matRipple
    [selected]="currentTheme"
    (selectedChange)="changeTheme($event)"
  >
    <nb-option
      *ngFor="let theme of themes"
      [value]="theme.value"
      matRipple
    >{{ theme.name }}</nb-option>
  </nb-select> -->
</div>

<div class="header-container no-printme">
  <nb-actions size="small">

    <!--<nb-action class="control-item">
      <nb-search
        type="rotate-layout"
        matRipple
        [matRippleUnbounded]="true"
        [matRippleCentered]="true"
      ></nb-search></nb-action>-->

    <nb-action class="control-item" icon="email-outline" matRipple [matRippleUnbounded]="true"
      [matRippleCentered]="true"></nb-action>

    <!--<nb-action class="control-item" matRipple [nbPopover]="notificationTemplate" [nbPopoverPlacement]="'bottom'"
      [nbPopoverTrigger]="'click'">
      <nb-icon icon="bell-outline"></nb-icon>
      <span class="badge" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
    </nb-action>-->
    <nb-action class="control-item" matRipple (click)="onBellClick()" [nbPopover]="notificationTemplate" [nbPopoverPlacement]="'bottom'" [nbPopoverTrigger]="'click'">
      <div class="notification-wrapper small">
        <i class="pi pi-bell bell-icon"></i>
        <span class="badge" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
      </div>
    </nb-action>
    

    <ng-template #notificationTemplate>
      <div class="notification-dropdown">
        <h6 class="notification-title"><b>Notifications</b></h6>
        <ul *ngIf="notifications.length > 0; else noData" class="notification-list">
          <li *ngFor="let n of notifications" (click)="openNotificationComponent()" class="notification-item"
            [class.new]="n.isNew">
            <div class="notification-content">
              <strong>New reservation:</strong> {{ n.FirstName }} {{ n.LastName }}<br>
              <span><strong>Check-in:</strong> {{ n.CheckIn | date: 'MMM d, yyyy' }}</span>,
              <span><strong>Check-out:</strong> {{ n.CheckOut | date: 'MMM d, yyyy' }}</span><br>
              <span><strong>Channel:</strong> {{ n.Channel }}</span>
            </div>
          </li>
        </ul>
        <button class="view-all-button" (click)="openNotificationComponent()">View All Notifications</button>
        <ng-template #noData>
          <p class="no-data">No new notifications</p>
        </ng-template>
      </div>
    </ng-template>

    <nb-action class="user-action" *nbIsGranted="['view', 'user']" matRipple [matRippleUnbounded]="true"
      [matRippleCentered]="true">
      <nb-user nbContextMenuTag="my-context-menu" [nbContextMenu]="userMenu" [onlyPicture]="userPictureOnly"
        [name]="userDetail?.userName" [picture]="user?.picture">
      </nb-user>
    </nb-action>
  </nb-actions>
</div>